import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Routes from 'presentation/routes';
import { CheckCircleIcon } from 'react-line-awesome';
import './index.css';

export interface ModernProductCardProps {
  icon: string;
  title: string;
  description?: string;
  itemsDescription: string[];
  enterpriseType?: string;
  image?: string;
  layout?: 'vertical' | 'horizontal';
}

export const ModernProductCard = (props: ModernProductCardProps): React.ReactElement => {
  const history = useHistory();
  const { layout = 'vertical', image } = props;

  const navigateToDetail = () => {
    history.push(`${Routes.products}/${props.enterpriseType}/${props.title}`);
  };

  return (
    <Card className={`modern-product-card h-100 border-0 ${layout === 'horizontal' ? 'modern-product-card-horizontal' : ''}`}>
      <div className={`card-horizontal-container ${layout === 'horizontal' ? 'd-flex h-100' : 'd-flex flex-column h-100'}`}>
        <Card.Body className={`flex-grow-1 d-flex flex-column text-left align-items-start card-body-content ${layout === 'horizontal' ? 'card-body-horizontal' : 'w-100'}`}>
          <div className="product-icon-wrapper mb-3 mb-md-4">
            {props.icon && props.icon.startsWith('la ') ? (
              <i className={`${props.icon} text-danger`} style={{ fontSize: '48px' }}></i>
            ) : (
              <img src={props.icon} alt={props.title} className="product-icon-img" />
            )}
          </div>

          <h4 className="product-card-title title-bryant mb-2 mb-md-3">
            {props.title}
          </h4>

          {props.description && (
            <p className="product-card-description mb-3 mb-md-4">
              {props.description}
            </p>
          )}

          <ul className="product-card-benefits list-unstyled mb-3 mb-md-4">
            {props.itemsDescription.map((benefit, idx) => (
              <li key={idx} className="d-flex align-items-start mb-2 mb-md-3">
                <span className="benefit-check-icon mr-2">
                  <CheckCircleIcon />
                </span>
                <span className="benefit-text">{benefit}</span>
              </li>
            ))}
          </ul>

          <Button
            variant="danger"
            onClick={navigateToDetail}
            className={`btn-zu-premium rounded-pill mt-auto ${layout === 'horizontal' ? 'align-self-center' : 'w-100'}`}
          >
            SOLICITAR MI CRÉDITO
          </Button>
        </Card.Body>

        {layout === 'horizontal' && image && (
          <div className="product-card-image-wrapper">
            <img
              src={image}
              alt={props.title}
              className={`product-card-image product-card-image-${props.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')} ${
                /motocicleta|tuktuk|tuk tuk/i.test(props.title)
                  ? 'product-card-image-vehicle'
                  : /automóvil|automovil/i.test(props.title)
                  ? 'product-card-image-auto'
                  : ''
              }`}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default ModernProductCard;
